<template>
    <section class="">
      <div class="ebmp_box_privacy">
      <div class="title">소중한 <span class="forg">개인정보!</span><br />
      비밀번호를 변경하여 지켜주세요.</div>
      <span class="k-icon k-i-lock title_img"></span>
      <div class="txt_small">3개월 동안 비밀번호를 변경하지 않으셨네요!<br />
      조금 불편하시더라도 지금 비밀번호를 변경하시면<br />개인정보 피해를 막을 수 있습니다.</div>
        <ul class="filter_list">
          <li class="w100">
            <dt>현재 비밀번호</dt>
            <input ref="originalPasswordRef"
                   v-model="originalPassword"
                   class="k-textbox"
                   name="originalPassword"
                   :style="'width: 100%;'"
                   maxlength="20"
                   placeholder="현재 비밀번호를 입력해 주세요."
                   type="password" />
          </li>
          <li class="w100">
            <dt>새 비밀번호 입력</dt>
            <input ref="newPasswordRef"
                   name="newPassword"
                   v-model="newPassword"
                   class="k-textbox"
                   :style="'width: 100%;'"
                   @change="newPwKeyUp"
                   maxlength="20"
                   placeholder="새 비밀번호를 입력해 주세요."
                   type="password" />

            <div class="msg_area" v-html="passwordComfirmMsg"></div>
          </li>
          <li class="w100">
            <dt>새 비밀번호 확인</dt>
            <input ref="newPasswordConfirmRef"
                   name="newPasswordConfirm"
                   v-model="newPasswordConfirm"
                   class="k-textbox"
                   :style="'width: 100%;'"
                   @change="newPwConfirmKeyUp"
                   maxlength="20"
                   placeholder="새 비밀번호를 한번 더 입력해 주세요."
                   type="password" />
            <div class="msg_area" v-html="passwordCheckComfirmMsg"></div>
          </li>
        </ul>
        <div class="info_txt">
          ※ 비밀번호는 영문, 숫자, 특수기호를 혼합한 8~20자리로 설정이 가능합니다.<br />
          ※ 기존에 사용하셨던 비밀번호는 사용하실 수 없습니다.
        </div>
        <div class="box_btn">
            <button type="submit"
                    @click="changePassword"
                    class="large_btn orange"
                    v-bind:disabled="!validateCheck || !originalPassword || !newPasswordConfirm || !newPassword">네, 지금 변경 할래요.</button>
            <button type="submit" @click="changePasswordDate" class="large_btn mt10">아니오. 다음에 변경 할래요.(3개월)</button>
        </div>
        </div>
    </section>
</template>




<script>
  import ApiUtil from '@/api/api.util'
  import ApiConfig from '@/api/api.config'
  import EtnersCommonUtil from '../common/etners.common.util'
  import EtnersDateTimeUtil from '@/common/etners.datetime.util'

  export default {
    name: 'ChangePassword',

    data() {
      return {
        originalPassword : null,
        newPassword : null,
        newPasswordConfirm : null,
        loginUserToken: sessionStorage.lutk,
        passwordComfirmMsg: '<span class="msg_green"></span>',
        passwordCheckComfirmMsg: '<span class="msg_green"></span>',
        validateCheck: false,
      }

    },
    mounted() {
    },
    methods: {
      newPwKeyUp: function (e) {
        const matched = /(?=.*\d{1,50})(?=.*[~`!@#$%\^&*()-+=]{1,50})(?=.*[a-zA-Z]{2,50}).{8,50}$/.test(this.newPassword)
        if (!matched) {
          this.validateCheck = false
          this.passwordComfirmMsg = '<span class="msg_red">조건에 일치하지 않는 비밀번호입니다.</span>'
        } else if (matched) {
          this.validateCheck = true
          this.passwordComfirmMsg = '<span class="msg_green">조건에 일치하는 비밀번호입니다.</span>'
        }
        if(this.newPasswordConfirm != null) {
          if (this.newPasswordConfirm !== this.newPassword) {
            this.validateCheck = false
            this.passwordCheckComfirmMsg = '<span class="msg_red">입력한값이 일치하지 않습니다.</span>'
          } else if (this.newPasswordConfirm == this.newPassword) {
            this.passwordCheckComfirmMsg = '<span class="msg_green">입력한값이 일치합니다.</span>'
            this.validateCheck = true
          }
        }
      },
      newPwConfirmKeyUp: function (e) {
        const matched = /(?=.*\d{1,50})(?=.*[~`!@#$%\^&*()-+=]{1,50})(?=.*[a-zA-Z]{2,50}).{8,50}$/.test(this.newPasswordConfirm)
        this.passwordCheckComfirmMsg = '<span class="msg_green"></span>'
        if (this.newPassword !== this.newPasswordConfirm) {
          this.validateCheck = false
          this.passwordCheckComfirmMsg = '<span class="msg_red">입력한값이 일치하지 않습니다.</span>'
        } else if (this.newPassword == this.newPasswordConfirm && !matched ) {
          this.passwordCheckComfirmMsg = '<span class="msg_green">입력한값이 일치합니다.</span>'
          this.validateCheck = false
        } else if (this.newPassword == this.newPasswordConfirm && matched) {
          this.passwordCheckComfirmMsg = '<span class="msg_green">입력한값이 일치합니다.</span>'
          this.validateCheck = true
        }

      },

      changePasswordDate() {
        const vm = this
        let param = {
          loginUserToken: sessionStorage.lutk
        }
        ApiUtil.post(`${ApiConfig.ssoDomain}/v1/ebmp/resetUserPasswordDate.json`, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
          sessionStorage.setItem('isPwdDateOver', 'N')
          location.href = '/'
        })


      },

      changePassword() {
        const vm = this
        if (!vm.validateCheck) {
          kendo.alert('입력값을 확인해주세요')
          return false
        }
        let param = {
          loginUserToken: sessionStorage.lutk,
          originalUserPwd : vm.originalPassword,
          changeUserPwd  : vm.newPassword,
        }
        ApiUtil.post(`${ApiConfig.ssoDomain}/v1/ebmp/resetUserPassword.json`, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }

          const resultStatus = response.data.resultStatus

          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
          sessionStorage.setItem('isPwdDateOver', 'N')
          location.href = '/'
        })

      },

    },
  }
</script>

<style>
</style>
